import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const InfoIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="M7.26 4.2c0-.41.34-.76.74-.76.4 0 .74.35.74.76 0 .41-.35.74-.74.74s-.74-.35-.74-.74Zm.18 8.37V6.11h1.12v6.46H7.44Z M12.95 2c.58 0 1.05.47 1.05 1.05v9.9c0 .58-.47 1.05-1.05 1.05h-9.9C2.47 14 2 13.53 2 12.95v-9.9C2 2.47 2.47 2 3.05 2h9.9Zm0-1h-9.9C1.92 1 1 1.92 1 3.05v9.9C1 14.08 1.92 15 3.05 15h9.9c1.13 0 2.05-.92 2.05-2.05v-9.9C15 1.92 14.08 1 12.95 1Z" />
  </IconWrapper>
)

export default InfoIconSmall
